// 更多的配置可以使用 JS SDK 获取地址：//connect.qq.com/qc_jssdk.js
// 参考http://wiki.connect.qq.com/%E5%BC%80%E5%8F%91%E6%94%BB%E7%95%A5_server-side Authorization_Code方式 开发攻略_Server-side
module.exports.login = function (options) {
  var appid = options.appid
  var redirecturi = options.redirecturi
  var url = 'https://graph.qq.com/oauth2.0/authorize?client_id=' + appid + '&response_type=code&redirect_uri=' + encodeURIComponent(redirecturi)
  location.href = url
  // 将跳转到https://urlsec.qq.com/login/redirect?url=lingkun&code=847B57359A2AAF1002740B8E80535FCB
}
